module.exports = __webpack_public_path__ + "img/wema-customized-pos.2c5bd3c5.png";